import { Command } from 'cmdk'
import { Search, Users } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Modal } from '@/components/ui/modal'
import { useAuth } from '@/lib/auth/AuthProvider'
import { visibleNav } from './nav'

/** ⌘K / Ctrl+K: sayfalar arasında gezinme ve hesaplarda arama. */
export function CommandPalette({ open, onOpenChange }: { open: boolean; onOpenChange: (v: boolean) => void }) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const navigate = useNavigate()
  const [q, setQ] = useState('')

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        onOpenChange(!open)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onOpenChange])

  const go = (to: string) => {
    onOpenChange(false)
    setQ('')
    void navigate(to)
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('common.search')} variant="bare" size="lg">
      <Command label={t('common.search')} className="[&_[cmdk-group-heading]]:px-3 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:text-muted-foreground">
        <div className="flex items-center gap-2 border-b px-3">
          <Search className="size-4 text-muted-foreground" />
          <Command.Input value={q} onValueChange={setQ} placeholder={t('common.searchPlaceholder')} className="h-12 w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground" />
        </div>
        <Command.List className="scrollbar-none max-h-80 overflow-y-auto p-2">
          <Command.Empty className="py-6 text-center text-sm text-muted-foreground">{t('common.empty')}</Command.Empty>
          {q.trim() && can('accounts.read') ? (
            <Command.Group heading={t('nav.accounts')}>
              <Command.Item value={`hesap-ara ${q}`} onSelect={() => go(`/accounts?q=${encodeURIComponent(q.trim())}`)} className="flex cursor-default items-center gap-2 rounded-md px-3 py-2 text-sm data-[selected=true]:bg-muted">
                <Users className="size-4 text-muted-foreground" />
                “{q.trim()}” — {t('nav.accounts')}
              </Command.Item>
            </Command.Group>
          ) : null}
          {visibleNav(can).map((g) => (
            <Command.Group key={g.key} heading={t(`nav.groups.${g.key}`)}>
              {g.items.map((i) => (
                <Command.Item key={i.key} value={t(`nav.${i.key}`)} onSelect={() => go(i.to)} className="flex cursor-default items-center gap-2 rounded-md px-3 py-2 text-sm data-[selected=true]:bg-muted">
                  <i.icon className="size-4 text-muted-foreground" />
                  {t(`nav.${i.key}`)}
                </Command.Item>
              ))}
            </Command.Group>
          ))}
        </Command.List>
      </Command>
    </Modal>
  )
}
